import { Component } from '@angular/core';
import { Button } from '@shared/components';

@Component({
  selector: 'app-not-found',
  imports: [Button],
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
})
export class NotFound {}
